<div class="container-fluid height-100 w-100 d-flex align-items-center justify-content-center default">

    <div class="container-waiting">
        <div class="iconeSDLV">
            <img alt="" class="icon_sdlv" src="../../../assets/images/logo_sport_ville.svg">
        </div>
        <p class="waiting-title">Les inscriptions sportives sont suspendues.</p>

        <p class="waiting-sub-title">Rendez-vous le {{dateAfterLimit | date: "dd MMMM"}} <br>
          pour vous inscrire sur la saison {{currentYear}}-{{currentYear + 1}}.</p>
    </div>


</div>
